class CloseMessageModal {
    // 1. describe and create/initiate object
    constructor() {
      this.closeModalButton = document.querySelector("#close-modal")
      this.modalContainer = document.querySelector(".museum-closed-message")

      this.events()
    }
  
    // 2. events
    events() {
      if ( this.closeModalButton )  {
        this.closeModalButton.addEventListener("click", (e) =>
        
          {
            this.closeModal(e)
            console.log("button clicked")
          }
        )
      }
    }
  
    // 3. methods
    closeModal() {
      this.modalContainer.classList.remove("show")
    }
  }
  
  export default CloseMessageModal 
  